/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Google_Drive_Choose_MoreInputs */

const en_google_drive_choose_more = /** @type {(inputs: Google_Drive_Choose_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose more files`)
};

const es_google_drive_choose_more = /** @type {(inputs: Google_Drive_Choose_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elegir más archivos`)
};

/**
* | output |
* | --- |
* | "Choose more files" |
*
* @param {Google_Drive_Choose_MoreInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const google_drive_choose_more = /** @type {((inputs?: Google_Drive_Choose_MoreInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Google_Drive_Choose_MoreInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_google_drive_choose_more(inputs)
	return en_google_drive_choose_more(inputs)
});